"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Link: true
};
exports.Link = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Text = require("../Text");
var _Theme = require("../Theme");
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Link = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    size,
    color = "default",
    leadingIcon,
    trailingIcon,
    asButton = false,
    ...props
  } = _ref;
  const {
    theme: {
      link: linkTheme
    }
  } = (0, _Theme.useThemeConfig)();
  size = size || linkTheme.defaultSize;
  return /*#__PURE__*/_react.default.createElement(_Text.Text, _extends({
    as: asButton ? "button" : "a",
    ref: ref,
    variant: linkTheme.variants[size],
    className: (0, _classnames.default)(linkTheme.base, linkTheme[color], {
      [linkTheme.itemsCenter]: leadingIcon || trailingIcon
    }, className)
  }, props), leadingIcon ? /*#__PURE__*/_react.default.cloneElement(leadingIcon, {
    "aria-hidden": true,
    className: "inline-block mr-4"
  }) : "", children, trailingIcon ? /*#__PURE__*/_react.default.cloneElement(trailingIcon, {
    "aria-hidden": true,
    className: "inline-block ml-4"
  }) : "");
});
exports.Link = Link;
Link.displayName = "Link";